<template>
  <div class="cloud-icon-library">
    <div class="bg">
      <div class="search-title">搜索条件</div>
      <div style="margin:24px 0">
        <span class="basic-search">基本搜索：</span>
        <a-input-group compact class="input-search" >
          <a-select defaultValue="1" style="height:34px;width:120px;float:left" @change="handleSelectIntention">
            <a-select-option title="按意图名称" value="1">按意图名称</a-select-option>
            <a-select-option title="按样本内容" value="2">按样本内容</a-select-option>
          </a-select>
          <a-input-search
            placeholder="请输入搜索内容"
            @search="onSearch"
            style="width:284px;height:32px;float:left"
            v-model="keywordValue"
          />
        </a-input-group>
      </div>
      <div>
        <div style="width:50%;float:left">
          <span class="basic-search">场景类型：</span>
          <a-select style="width:180px;float:left"
            placeholder="不限"
            @change="handleSelectChange1"
          >
            <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in sceneList" :key="index">
              {{item.name}}
            </a-select-option>
          </a-select>
        </div>
        <div style="width:50%;float:left">
          <span class="basic-search">样本数量：</span>
          <a-select style="width:180px;float:left"
            placeholder="不限"
            @change="handleSelectChange2"
          >
            <a-select-option title="1-20" value="1">
              1-20
            </a-select-option>
            <a-select-option title="21-50" value="2">
              21-50
            </a-select-option>
            <a-select-option title="51-200" value="3">
              51-200
            </a-select-option>
            <a-select-option title="201-500" value="4">
              201-500
            </a-select-option>
            <a-select-option title="500以上" value="5">
              500以上
            </a-select-option>
          </a-select>
        </div>
      </div>
    </div>
    <div class="intention">
      <div class="intention-content">
        <a-row :gutter="16" style="height:100%">
          <a-col class="gutter-row" :span="12" style="height:100%;display:flex;flex-direction: column">
            <div class="title" style="height:30px;color:rgba(80, 80, 80, 1);font-size:18px">意图列表</div>
            <div class="gutter-box">
              <div style="overflow-y:auto;padding-bottom:24px">
                <a-table :data-source="data"  :customRow="rowClick" :pagination='false' class="cloudy-table" :rowKey="record => record.id">
                  <a-table-column key="name" title="意图名称" data-index="name">
                    <template slot-scope="text, record">
                      <div :class="{'active':currentId==record.id}">
                        {{record.name}}
                      </div>
                    </template>
                  </a-table-column>
                  <a-table-column key="action" title="样本数量" class="table-sample">
                    <template slot-scope="text, record">
                      <div :class="{'active':currentId==record.id}">
                        <span>{{ record.sampleCount }}</span>
                        <a-icon v-if="isLogin" @click="saveToSelf(record.id)" type="copy" />
                      </div>
                    </template>
                  </a-table-column>
                </a-table>
                <div v-if="ifShowLoadMore1" style="text-align:center;cursor:pointer;margin-top:15px" @click="onChangeSample1">点击加载更多</div>
                <div v-if="!ifShowLoadMore1 && total1 != 0" style="text-align:center;cursor:pointer;margin-top:15px">已经没有啦~</div>
              </div>
            </div>
          </a-col>
          <a-col class="gutter-row" :span="12" style="height:100%;display:flex;flex-direction: column">
            <div class="title" style="height:30px;color:rgba(80, 80, 80, 1);font-size:18px">意图样本</div>
            <div class="gutter-box ">
              <div class="sample" style="padding-bottom:24px">
                <a-table :columns="columnsSample" :dataSource="intentionSampleList" :pagination='false' :rowKey="record => record.id">
                </a-table>
                <div v-if="ifShowLoadMore2" style="text-align:center;cursor:pointer;margin-top:15px" @click="onChangeSample2">点击加载更多</div>
                <div v-if="!ifShowLoadMore2 && total2 != 0" style="text-align:center;cursor:pointer;margin-top:15px">已经没有啦~</div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <!-- <router-link target="_blank" rel="opener" to="/Communication"  class="dialogBox">
      <a-icon style="z-index:1000;font-size:25px" type="message" />
    </router-link> -->
    <a-modal
      :mask-closable="true"
      title="Title"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
      okText="确认" cancelText="取消"
    >
      <div style="">
        <a-select style="width:174px"
          @change="handleSelectPro"
          v-model="demodata"
        >
          <a-select-option :title="item.name" :value="item.id"  v-for="(item, index) in proList" :key="index">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: '意图名称',
    key: 'name',
    dataIndex: 'name',
    id: 'id'
  },
  {
    title: '样本数量',
    key: 'sampleCount',
    dataIndex: 'sampleCount',
    id: 'id'
  },
];
const columnsSample = [
  {
    title: '样本内容',
    key: 'content',
    dataIndex: 'content',
  },
];
export default {
  name: 'CloudIconLibrary',
  props: {
    msg: String
  },
  data() {
    return {
      data: [],
      columns,
      sceneList: [],
      keywordValue: '',
      keyword: '',
      sceneId: '',
      minSampleCount: '',
      maxSampleCount: '',
      sampleKeyword: '',
      current: 1,
      size: 20,
      currentChoose: 1,
      intentionSampleList: [],
      columnsSample,
      currentSample: 1,
      recordData: null,
      total1: 0,
      total2: 0,
      visible: false,
      proList: [],
      currentProId: '',
      currentIntentionId: '',
      demodata: '请选择',
      isLogin: false,
      ifShowLoadMore1: false,
      ifShowLoadMore2: false,
      currentId: '',
    }
  },
  methods: {
    saveToSelf(id){
      this.visible = true
      this.currentIntentionId = id
      this.currentProId = ''
    },
    onSearch() {
      this.intentionSampleList = []
      if(this.currentChoose == 1){
        this.keyword = this.keywordValue
        this.sampleKeyword = ''
      }else{
        this.sampleKeyword = this.keywordValue
        this.keyword = ''  
      }
      this.current = 1
      this.queryData(0)
    },
    handleSelectIntention(value) {
      if(this.currentChoose != value){
        this.currentChoose = value
        this.keywordValue = ''
      }
    },
    handleSelectChange1(value) {
      this.intentionSampleList = []
      this.sceneId = value
      this.current = 1
      this.queryData(0)
    },
    handleSelectChange2(value) {
      this.intentionSampleList = []
      switch(value){
        case '1':
          this.minSampleCount = 1
          this.maxSampleCount = 20
          break;
        case '2':
          this.minSampleCount = 21
          this.maxSampleCount = 50
          break;
        case '3':
          this.minSampleCount = 51
          this.maxSampleCount = 200
          break;
        case '4':
          this.minSampleCount = 201
          this.maxSampleCount = 500
          break;
        case '5':
          this.minSampleCount = 500
          this.maxSampleCount = ''
          break;
        default:
          this.minSampleCount = ''
          this.maxSampleCount = ''
          break;
      }
      this.current = 1
      this.queryData(0)
    },
    onChangeSample1() {
      this.current ++
      this.queryData(1)
    },
    queryData(type) {
      if(type == 0){
        this.data = []
        this.ifShowLoadMore2 = false
        this.total2 = 0
      }
      this.axios(
        {
          method:'get',
          url:'/api/public/intention/list', 
          params:{
            keyword:this.keyword,
            sceneId:this.sceneId,
            minSampleCount:this.minSampleCount,
            maxSampleCount:this.maxSampleCount,
            sampleKeyword:this.sampleKeyword,
            current:this.current,
            size:10,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.data.push(...response.data.data.records)
          this.total1 = response.data.data.total
          if(this.total1 == this.data.length){
            this.ifShowLoadMore1 = false
          }else{
            this.ifShowLoadMore1 = true
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    querySampleData(type) {
      if(type == 0){
        this.intentionSampleList = []
        this.countTotalNum2 = 0
      }
      this.axios(
        {
          method:'get',
          url:'/api/public/intention/sample/list', 
          params: {
            current: this.currentSample,
            size: 20,
            intentionId: this.recordData.id
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.intentionSampleList.push(...response.data.data.records)
          this.total2 = response.data.data.total
          this.countTotalNum2 = this.intentionSampleList.length
          if(this.intentionSampleList.length == this.total2){
            this.ifShowLoadMore2 = false
          }else{
            this.ifShowLoadMore2 = true
          }
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    rowClick: function(record){
      return {
        on: {
          click: () => {
            this.recordData = record
            this.currentSample = 1
            this.querySampleData(0)
            this.currentId = record.id
          }
        }
      }
    },
    onChangeSample2() {
      this.currentSample ++
      this.querySampleData(1)
    },
    handleOk() {
      if(this.currentProId == ''){
        this.$message.error('当前还未选择项目');
      }else{
        this.visible = false
        this.demodata = '请选择'
        this.axios.post('/api/public/intention', {
          intentionId: this.currentIntentionId,
          projectId: this.currentProId
        })
        .then(response=> {
          if(response.data.code == 0){
            this.$message.success('保存成功');
          }else{
            this.$message.error(response.data.message);
          }
        })
        .catch(error=> {
          console.log(error)
        })
      }
    },
    handleCancel() {
      this.visible = false
    },
    handleSelectPro(value) {
      this.currentProId = value
    },
    queryProDataList() {
      this.axios.get('/api/dropdown/project')
      .then(response=> {
        if(response.data.code == 0){
          this.proList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    },
    querySence() {
      this.axios.get('/api/dropdown/scene')
      .then(response=> {
        if(response.data.code == 0){
          this.sceneList = response.data.data
        }else{
          this.$message.error(response.data.message);
        }
      })
      .catch(error=> {
        console.log(error)
      })
    }
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','edit');
    this.querySence()
    this.queryData(1)
    if(this.sessionData('get','token')){
        this.queryProDataList()
        this.isLogin = true
    }else{
        this.isLogin = false
    }
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .cloud-icon-library{
    height: 100%;
    background: #eee;
    display: flex;
		flex-direction: column;
    overflow-y: auto;
    padding-bottom: 70px;
    .bg{
      height: 192px;
      width: 1200px;
      margin: 24px auto;
      background: #fff;
      border-radius: 4px;
      padding: 24px;
      .search-title{
        color: rgba(51, 51, 51, 1);
        font-size: 18px;
      }
      .basic-search{
        float: left;
        color: rgba(153, 153, 153, 1);
        font-size: 14px;
        float: left;
        margin-top:5px;
        margin-right: 24px;
      }
      .input-search{
        width: 550px;
        height: 34px;
      }
    }
    .search-list{
      height: 80px;
      background: #fff;
      padding: 20px 0px 20px 40px;
      width: 1200px;
      border-radius: 8px;
    }
    .content{
      width: 1200px;
      margin: 0 auto;
    }
    .intention{
      overflow-y: auto;
      flex: 1;
      .intention-content{
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        background: #fff;
        border-radius: 4px;
        padding: 24px 24px 0 24px;
        .gutter-box{
          background: #fff;
          overflow-y: auto;
          flex: 1;
          flex-direction: column;
          .cloudy-table{
            div.active{
              background: rgba(34, 215, 187, 0.1);
              color: #22d7bb;
            }
            table div{
              padding: 8px 16px;
              cursor: pointer;
            }
            td,th{
              padding: 0px !important;
            }
          }
          .table-sample{
            i{
              display: none;
              float: right;
              margin-top:5px;
            }
            div:hover{
              i{
                display: inline-block;
              }
            }
          }
          td,th{
            padding-top: 8px;
            padding-bottom: 8px;
          }
          .title{
            font-size: 14px;
            font-weight: bold;
            color: rgba(80, 80, 80, 1);
            margin-bottom: 15px;
          }
          .sample{
            overflow-y: auto;
          }
        }
      }
    }
  }
</style>
